// removed by extract-text-webpack-plugin
module.exports = {"detailMap":"detail-map-module__detailMap___1eF3k","pin":"detail-map-module__pin___LWGkL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/detail-map/detail-map.module.scss
// module id = 444
// module chunks = 0